import getConfig from 'next/config';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './ProductCount.module.scss';

import { useProductCountData } from './data/useProductCountData';

const { publicRuntimeConfig } = getConfig();

export const ProductCount = ({ isListView = false, positionOnPage = 0 }) => {
  const { productContext, router } = useProductCountData();
  const { pageSize } = publicRuntimeConfig;

  const { totalNumberOfResults } = productContext;

  const { page } = router;

  const currentPage = parseInt(page, 10);

  if (!totalNumberOfResults) {
    return null;
  }

  // Calculate the position of the product in the total list of all products retrieved
  // e.g. for a page size of 192, the first product on page 2 is product 193
  // Note that positionOnPage is zero-based, so we add 1 to it
  // i.e. positionOnPage 0 is product 1 on that page
  const productPositionInList =
    (currentPage - 1) * pageSize + positionOnPage + 1;

  const copy = `You've viewed ${productPositionInList.toLocaleString(
    'en'
  )} of ${totalNumberOfResults.toLocaleString('en')}`;

  return (
    <aside
      className={classnames(styles.productCountInfo, {
        [styles['product-count__list-view']]: isListView,
      })}
    >
      <span data-testid="product-count-copy">{copy}</span>
    </aside>
  );
};

ProductCount.propTypes = {
  positionOnPage: PropTypes.number,
};

export default ProductCount;
